import './CSS/EmailStyle.css';
function Email(props) {
    return (
        <h1 id="emailcolor"></h1>          
    );
  }
  
  export default Email;
  